<template>
  <div class="flex flex-col">
    <transition name="modal">
      <delete-modal
        v-if="showDeleteModal"
        :loading="loadingDelete"
        @close="closeDeleteModal()"
        @confirmDelete="deleteElement"
      ></delete-modal>
    </transition>

    <router-link
      v-if="hasPermission('edit_incomes')"
      :to="{ name: 'incomesCreateForm' }"
      class="primary-button mx-0 mt-2"
      >Crear Ingreso</router-link
    >

    <div class="card mt-6">
      <table class="table-auto text-sm mt-2">
        <thead class="text-left">
          <tr class="bg-primary-100">
            <th class="px-4 py-3 rounded-l-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">ID</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Concepto</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Monto</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Fecha</th>
            <th class="px-4 py-3 rounded-r-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="income in incomes" :key="income.id" class="table-row">
            <td class="table-cell">
              {{ income.id }}
            </td>
            <td class="table-cell">{{ income.income_category.name }}</td>
            <td class="table-cell">
              {{ integerToCurrency(income.amount) }}
            </td>
            <td class="table-cell">
              {{ formatDatetime(income.date_time) }}
            </td>

            <td class="table-cell">
              <div class="flex space-x-2">
                <router-link
                  :to="{ name: 'incomesEditForm', params: { id: income.id } }"
                >
                  <edit-button />
                </router-link>

                <delete-button
                  @click.prevent="
                    incomeToDelete = income;
                    openDeleteModal();
                  "
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="loading" class="flex w-full h-full items-center">
        <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
      </div>
    </div>

    <pagination
      :current-page="currentPage"
      :total-pages="totalPages"
      @page-change="onPageChange"
    />
  </div>
</template>

<script>
import api from "@/api";
import deleteMixin from "@/mixins/deleteMixin";
import Pagination from "@/components/ui/Pagination.vue";
import { formatDatetime } from "@/utils/dateFormatter";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Incomes",

  components: {
    Pagination,
  },

  data() {
    return {
      incomes: null,
      loading: false,
      loadingDelete: false,
      incomeToDelete: null,
      currentPage: 1,
      totalPages: 0,
    };
  },

  mixins: [deleteMixin],

  created() {
    this.$store.commit("setSelectedTab", "accounting");

    this.loadIncomes();
  },

  methods: {
    formatDatetime,

    integerToCurrency,

    async loadIncomes() {
      this.loading = true;

      try {
        const response = await api.incomes.getAllWithQueryParams([
          {
            name: "page",
            value: this.currentPage,
          },
        ]);
        this.incomes = response.data;
        this.currentPage = response.current_page;
        this.totalPages = response.last_page;
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    onPageChange(page) {
      this.currentPage = page;
      this.loadIncomes();
    },

    async deleteElement() {
      this.loadingDelete = true;

      try {
        const response = await api.incomes.delete(this.incomeToDelete.id);
        this.incomeToDelete = null;
        this.$store.dispatch("successSnack", response.message);
        this.closeDeleteModal();
        this.loadIncomes();
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingDelete = false;
    },
  },
};
</script>